// src/main.js
import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import { i18n } from './i18n';
// Police Inter, celle de l'app mobile (05/10/2026). Avant, `font-family: Inter` était déclaré
// sans que la police soit chargée : la webapp s'affichait dans la police du système. Hébergée
// avec la webapp (paquet @fontsource) plutôt que chez Google : aucune adresse IP de visiteur ne
// part chez un tiers. 300 sert au monogramme « UL ».
import '@fontsource/inter/300.css';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import './assets/css/main.css';

createApp(App).use(store).use(router).use(i18n).mount('#app');
